<template>
  <section>
    <h1 class="section-head">ผู้ใช้งาน</h1>
    <router-link class="button is-success is-pulled-right" :to="'/user/add/'" v-can="'add_user'"><i class="fas fa-plus"></i>เพิ่ม</router-link>
    <div>
      <b-table
        :data="users"
        selectable @click="selected"
        :selected.sync="selectedItem"
        :hoverable="true"
        :loading="isTableLoading"
      >
        <template slot-scope="props">
          <b-table-column field="id" label="ID" width="40" numeric>
              {{ props.row.id }}
          </b-table-column>

          <b-table-column field="name" label="ชื่อผู้ใช้งาน">
              {{ props.row.first_name }} {{ props.row.last_name }}
          </b-table-column>

        </template>
      </b-table>
      <div class="notification has-text-centered" v-if="users.length == 0 && !isTableLoading">ไม่พบข้อมูล</div>
    </div>
  </section>
</template>

<script>
  import UserModel from '@/model/user_model'

  export default {
    name: 'User',
    data() {
      return {
        users: [],
        selectedItem: {},
        lastSelected: {},
        isTableLoading: true
      }
    },
    mounted() {
      this.init();
    },
    methods: {
      async init(){
        this.users = await UserModel.get_users();
        this.isTableLoading = false;
      },
      selected(item) {
        if(!this.can("edit_user|add_user|delete_user")){
          this.$buefy.toast.open('คุณไม่มีสิทธิ์ที่จะเข้าถึงส่วนนี้!');
          return;
        }
        if(this.lastSelected == item){
          this.$router.push({ path: '/user/edit/'+item.id })
        }
        this.lastSelected = item;
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/User/index.vue